import { ISummaryCounterStyles } from './summary-counter-styles';
import { IPluralizationForms, MppCurrencies } from '@arturin/core';

export interface ISummaryCounterData extends ISummaryCounterStyles {
  labels: IPluralizationForms;
  count?: number;
  currency?: MppCurrencies;
}
